/**
 * Текст ошибки запроса для пользователя. `ApiConnector.call` кладёт в `message` понятный
 * текст бэкенда для 4xx (например, «неверный код») и общий текст для 5xx и сети.
 * @param err      то, что бросил `ApiConnector.call`
 * @param fallback текст, если у ошибки нет `message`
 */
export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  if (err && typeof err === 'object' && 'message' in err) {
    const { message } = err as { message?: unknown };
    if (typeof message === 'string' && message) return message;
  }
  return fallback;
};

/**
 * HTTP-статус ошибки запроса.
 * @returns статус или `undefined`, если ответа не было (сеть, отмена запроса)
 */
export const getApiErrorStatus = (err: unknown): number | undefined => {
  if (err && typeof err === 'object' && 'statusCode' in err) {
    const { statusCode } = err as { statusCode?: unknown };
    if (typeof statusCode === 'number') return statusCode;
  }
  return undefined;
};

/**
 * Подробности ошибки из `error.details` ответа (например, невыполненные требования к паролю).
 * Показать можно только текст, поэтому берём строки, остальное отбрасываем.
 * @returns непустые строки подробностей или пустой массив
 */
export const getApiErrorDetails = (err: unknown): string[] => {
  if (!err || typeof err !== 'object' || !('details' in err)) return [];
  const { details } = err as { details?: unknown };
  const items: unknown[] = Array.isArray(details) ? details : [details];
  return items.filter(
    (item): item is string => typeof item === 'string' && item.length > 0
  );
};

/**
 * Неизвестно, дошёл ли запрос до конца: ответа нет или сервер упал. Такой запрос повторяют
 * с тем же ключом идемпотентности. На ответ 4xx сервер уже дал окончательный отказ.
 */
export const isRetryableApiError = (err: unknown): boolean => {
  const status = getApiErrorStatus(err);
  return status === undefined || status >= 500;
};
